export const computeOrgClientIds = (admin_clients) => {
    const shipperIds =
        admin_clients?.filter((c) => c.user?.roles?.['SHIPPER']).map((c) => c.client_id) || [];

    const ownCarrierIds =
        admin_clients?.filter((c) => c.user?.roles?.['CARRIER']).map((c) => c.client_id) || [];

    const ownMmCarrierIds =
        admin_clients
            ?.filter((c) => c.user?.roles?.['MIDDLE_MILE_CARRIER'])
            .map((c) => c.client_id) || [];

    const networkCarrierIds =
        admin_clients
            ?.filter((c) => c.user?.roles?.['SHIPPER'])
            .flatMap(
                (s) =>
                    s.shipper_partnerships
                        ?.filter((sp) => sp.status === 'APPROVED')
                        .map((sp) => sp.carrier?.client_id)
                        .filter(Boolean) || []
            ) || [];

    const carrierIds = [...new Set([...ownCarrierIds, ...ownMmCarrierIds, ...networkCarrierIds])];

    return { shipperIds, carrierIds };
};
